import React from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { AdminContainer } from "../container";

export function LayoutScreen({
    children,
    maxWidth,
}: {
    children: React.ReactNode;
    maxWidth?: number;
}) {
    const styles: StyleProp<ViewStyle> = maxWidth
        ? {
              width: "100%",
              maxWidth,
              alignSelf: "center",
          }
        : {};

    return (
        <AdminContainer testID="layoutsListScreen">
            <View style={styles}>{children}</View>
        </AdminContainer>
    );
}
